// SubtaskInputWrapper.jsx: // Page view for editing a single task in detail.
import TaskInputInline from '@/features/tasks/components/forms/TaskInputInline';

/**
 * Wrapper that renders the inline subtask input at the correct indentation level.
 */
const SubtaskInputWrapper = ({ level, onSave, onCancel }) => (
  <div
    className="subtask-input-wrapper"
    style={/** @type {any} */ ({ '--level': level })}
  >
    <TaskInputInline onSave={onSave} onCancel={onCancel} dense={false} />
  </div>
);

export default SubtaskInputWrapper;
